<template>
  <div class="rider-info">
    <el-card class="region-settings-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">到时自动配送</div>
        </div>
      </template>
      <div class="region-settings-body">
        <p style="margin:0 0 8px;font-size:14px;color:#334155;">
          午餐自动配送：<strong>{{ autoSchedule.lunch_auto_deliver_at || '10:30' }}</strong>
          &nbsp;·&nbsp;
          晚餐自动配送：<strong>{{ autoSchedule.dinner_auto_deliver_at || '17:30' }}</strong>
        </p>
        <div class="rider-region-tip">{{ autoSchedule.note || '午餐 10:30 / 晚餐 17:30 自动将符合条件的订单变为「配送中」' }}</div>
      </div>
    </el-card>

    <el-card class="region-settings-card" shadow="never" style="margin-top: 16px;">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">配送区域设置</div>
        </div>
      </template>
      <div class="region-settings-body">
        <div class="region-tag-list">
          <el-tag
            v-for="item in deliveryRegionItems"
            :key="item.id"
            closable
            class="region-tag"
            @close="removeDeliveryRegion(item)"
          >
            {{ item.label }}
          </el-tag>
          <span v-if="!deliveryRegionItems.length" class="region-empty">暂无配送区域，请添加</span>
        </div>
        <div class="region-add-row">
          <el-input
            v-model="newRegionLabel"
            placeholder="输入新配送区域，如：温岭太平"
            maxlength="64"
            clearable
            @keyup.enter.native="addDeliveryRegion"
          />
          <el-button type="primary" icon="el-icon-plus" @click="addDeliveryRegion">添加</el-button>
        </div>
        <div class="rider-region-tip">与小程序地址页「配送区域」选项一致；骑手个人区域请从下列选项中选择</div>
      </div>
    </el-card>

    <el-card class="rider-card" shadow="never">
      <template slot="header">
        <div class="card-header">
          <div class="card-title">骑手个人信息</div>
          <div class="card-actions">
            <el-button
              class="btn-secondary"
              size="small"
              @click="downloadTemplate"
            >
              下载模板
            </el-button>
            <el-button
              class="btn-secondary"
              size="small"
              @click="exportToExcel"
            >
              导出Excel
            </el-button>
            <el-upload
              :show-file-list="false"
              :before-upload="handleImport"
              accept=".csv,.xls,.xlsx"
            >
              <el-button class="btn-secondary" size="small">导入Excel</el-button>
            </el-upload>
            <el-button
              class="btn-primary"
              icon="el-icon-plus"
              @click="openCreateDialog"
            >
              新增骑手
            </el-button>
          </div>
        </div>
      </template>
      <el-table
        :data="riders"
        size="small"
        style="width:100%"
        stripe
        class="rider-table"
      >
        <el-table-column prop="name" label="姓名" min-width="140" />
        <el-table-column prop="phone" label="联系方式" min-width="160" />
        <el-table-column prop="regions_label" label="配送区域" min-width="220" show-overflow-tooltip />
        <el-table-column prop="health_certificate_expiry" label="健康证到期时间" min-width="180">
          <template slot-scope="scope">
            {{ $formatDate(scope.row.health_certificate_expiry) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="140">
          <template slot-scope="scope">
            <span
              class="status-tag"
              :class="getStatusClass(scope.row.status)"
            >
              {{ getStatusText(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              size="small"
              class="btn-secondary"
              @click="openEditDialog(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              class="btn-secondary danger"
              @click="deleteRider(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="currentRider.id ? '编辑骑手' : '新增骑手'" :visible.sync="dialogVisible" width="520px">
      <el-form :model="currentRider" label-width="90px" class="rider-form">
        <el-form-item label="骑手">
          <el-select
            v-model="currentRider.employee_id"
            placeholder="从员工管理选择"
            style="width: 100%;"
            filterable
            @change="onEmployeePick"
          >
            <el-option
              v-for="e in employees"
              :key="e.id"
              :label="employeeOptionLabel(e)"
              :value="e.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="显示名称">
          <el-input v-model="currentRider.name" placeholder="默认使用员工姓名" />
          <div class="rider-region-tip">一名员工只需一条骑手记录，多个配送区域在下方添加即可</div>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="currentRider.phone" />
        </el-form-item>
        <el-form-item label="配送区域">
          <div
            v-for="(region, idx) in currentRider.regions"
            :key="'region-' + idx"
            class="region-row"
          >
            <el-select
              v-model="currentRider.regions[idx]"
              :placeholder="'请选择区域 ' + (idx + 1)"
              style="flex: 1;"
              filterable
              allow-create
              @change="onRegionChange"
            >
              <el-option
                v-for="r in deliveryRegionOptions"
                :key="r + '-' + idx"
                :label="r"
                :value="r"
              />
            </el-select>
            <el-button
              v-if="currentRider.regions.length > 1"
              type="text"
              class="region-remove"
              @click="removeRegion(idx)"
            >
              删除
            </el-button>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addRegion">添加区域</el-button>
          <div class="rider-region-tip">与小程序「配送区域」一致；可再填街道关键词，英文逗号分隔，如：温岭太平,太平街道</div>
        </el-form-item>
        <el-form-item label="健康证到期">
          <el-date-picker
            v-model="currentRider.health_certificate_expiry"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="currentRider.status" placeholder="请选择">
            <el-option label="空闲" value="idle" />
            <el-option label="配送中" value="delivering" />
            <el-option label="离线" value="offline" />
          </el-select>
        </el-form-item>
        <el-form-item label="绑定用户ID">
          <el-input
            v-model="currentRider.bind_user_ids"
            type="textarea"
            :rows="2"
            placeholder="小程序用户 ID，多个用英文逗号分隔"
          />
          <div class="rider-region-tip">绑定后该用户可在小程序「骑手订单」查看配送任务</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveRider">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { getAdminAuthHeader } from '../utils/auth'
import { triggerBlobDownload } from '../utils/fileExport'
import { guardUploadFile, validateCsvText } from '../utils/fileImport'

function riderAuthCfg (extra = {}) {
  return {
    ...extra,
    headers: { ...(extra.headers || {}), ...getAdminAuthHeader() }
  }
}

export default {
  name: 'RiderInfo',
  data () {
    return {
      riders: [],
      employees: [],
      dialogVisible: false,
      deliveryRegionItems: [],
      newRegionLabel: '',
      autoSchedule: {
        lunch_auto_deliver_at: '10:30',
        dinner_auto_deliver_at: '17:30',
        note: ''
      },
      currentRider: {
        id: '',
        employee_id: '',
        name: '',
        phone: '',
        regions: [''],
        health_certificate_expiry: '',
        status: 'idle',
        bind_user_ids: ''
      }
    }
  },
  computed: {
    deliveryRegionOptions () {
      return (this.deliveryRegionItems || []).map((x) => x.label).filter(Boolean)
    }
  },
  mounted () {
    this.fetchDeliveryRegions()
    this.fetchAutoSchedule()
    this.fetchRiders()
    this.fetchEmployees()
  },
  methods: {
    async fetchAutoSchedule () {
      try {
        const resp = await axios.get('/api/admin/rider/auto-delivery-schedule', riderAuthCfg())
        if (resp.data && resp.data.code === 200 && resp.data.data) {
          this.autoSchedule = Object.assign({}, this.autoSchedule, resp.data.data)
        }
      } catch (e) {
        /* keep defaults */
      }
    },
    async fetchDeliveryRegions () {
      try {
        const resp = await axios.get('/api/admin/delivery-regions', riderAuthCfg())
        if (resp.data && resp.data.code === 200 && Array.isArray(resp.data.data)) {
          this.deliveryRegionItems = resp.data.data
        }
      } catch (e) {
        this.deliveryRegionItems = []
      }
    },
    async addDeliveryRegion () {
      const label = String(this.newRegionLabel || '').trim()
      if (!label) {
        this.$message.warning('请输入配送区域名称')
        return
      }
      try {
        const resp = await axios.post('/api/admin/delivery-regions', { label }, riderAuthCfg())
        if (resp.data && resp.data.code === 200) {
          this.newRegionLabel = ''
          this.$message.success('添加成功')
          await this.fetchDeliveryRegions()
          return
        }
        this.$message.error((resp.data && resp.data.message) || '添加失败')
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || '添加失败'
        this.$message.error(msg)
      }
    },
    async removeDeliveryRegion (item) {
      if (!item || !item.id) return
      try {
        await this.$confirm(`确定删除配送区域「${item.label}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await axios.delete(`/api/admin/delivery-regions/${item.id}`, riderAuthCfg())
        this.$message.success('已删除')
        await this.fetchDeliveryRegions()
      } catch (e) {
        if (e === 'cancel') return
        const msg = (e.response && e.response.data && e.response.data.message) || '删除失败'
        this.$message.error(msg)
      }
    },
    employeeOptionLabel (e) {
      if (!e) return ''
      const name = e.name || e.username || ''
      const phone = e.phone ? ` · ${e.phone}` : ''
      return `${name}${phone}`
    },
    async fetchEmployees () {
      try {
        const resp = await axios.get('/api/admin/employees', riderAuthCfg())
        if (resp.data && resp.data.code === 200) {
          this.employees = resp.data.data || []
        }
      } catch (e) {
        this.employees = []
      }
    },
    onEmployeePick (employeeId) {
      const emp = this.employees.find((e) => String(e.id) === String(employeeId))
      if (!emp) return
      this.currentRider.phone = emp.phone || this.currentRider.phone
      if (!this.currentRider.id) {
        const existing = (this.riders || []).find((r) => String(r.employee_id) === String(employeeId))
        if (existing) {
          this.$message.warning('该员工已有骑手记录，请在列表中编辑，不要重复新增')
          this.openEditDialog(existing)
          return
        }
      }
      this.composeRiderDisplayName()
    },
    composeRiderDisplayName () {
      const emp = this.employees.find((e) => String(e.id) === String(this.currentRider.employee_id))
      if (!emp) return
      const empName = emp.name || emp.username || ''
      this.currentRider.name = empName
    },
    onRegionChange () {
      /* 显示名称与员工姓名一致，配送区域单独展示 */
    },
    addRegion () {
      if (!Array.isArray(this.currentRider.regions)) {
        this.currentRider.regions = ['']
      }
      this.currentRider.regions.push('')
    },
    removeRegion (idx) {
      if (!Array.isArray(this.currentRider.regions) || this.currentRider.regions.length <= 1) return
      this.currentRider.regions.splice(idx, 1)
    },
    parseRegionsFromRow (row) {
      if (Array.isArray(row.regions) && row.regions.length) {
        return [...row.regions]
      }
      const legacy = [row.region1, row.region2].filter((x) => x != null && String(x).trim() !== '')
      return legacy.length ? legacy : ['']
    },
    async fetchRiders () {
      try {
        const resp = await axios.get('/api/riders', riderAuthCfg())
        if (resp.data && resp.data.code === 200) {
          this.riders = resp.data.data || []
          return
        }
      } catch (e) {
        // 接口不可用时使用测试数据，避免页面空白
        this.riders = [
          {
            id: 'r1',
            name: '测试骑手A',
            phone: '13800000001',
            health_certificate_expiry: '2026-12-31',
            status: 'idle'
          },
          {
            id: 'r2',
            name: '测试骑手B',
            phone: '13800000002',
            health_certificate_expiry: '2026-10-31',
            status: 'delivering'
          }
        ]
        this.$message.warning('骑手接口不可用，已加载测试数据')
      }
    },
    openCreateDialog () {
      this.currentRider = {
        id: '',
        employee_id: '',
        name: '',
        phone: '',
        regions: [''],
        health_certificate_expiry: '',
        status: 'idle',
        bind_user_ids: ''
      }
      this.dialogVisible = true
    },
    openEditDialog (row) {
      const ids = Array.isArray(row.bound_user_ids) ? row.bound_user_ids : (row.user_id ? [row.user_id] : [])
      this.currentRider = {
        id: row.id,
        employee_id: row.employee_id || '',
        name: row.name,
        phone: row.phone,
        regions: this.parseRegionsFromRow(row),
        health_certificate_expiry: row.health_certificate_expiry,
        status: row.status,
        bind_user_ids: ids.join(',')
      }
      this.dialogVisible = true
    },
    async deleteRider (row) {
      try {
        await this.$confirm(`确定要删除骑手「${row.name}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await axios.delete(`/api/riders/${row.id}`, riderAuthCfg())
        this.$message.success('骑手已删除')
        this.fetchRiders()
      } catch (e) {
        if (e === 'cancel') return
        const msg = (e.response && e.response.data && e.response.data.message) || '删除失败'
        this.$message.error(msg)
      }
    },
    async saveRider () {
      try {
        if (!this.currentRider.employee_id) {
          this.$message.warning('请从员工管理选择骑手')
          return
        }
        this.composeRiderDisplayName()
        const regions = (this.currentRider.regions || [])
          .map((x) => String(x || '').trim())
          .filter(Boolean)
        const payload = {
          name: this.currentRider.name,
          phone: this.currentRider.phone,
          employee_id: this.currentRider.employee_id,
          regions,
          health_certificate_expiry: this.currentRider.health_certificate_expiry,
          status: this.currentRider.status,
          user_ids: String(this.currentRider.bind_user_ids || '').trim()
        }
        if (this.currentRider.id) {
          const resp = await axios.put(`/api/riders/${this.currentRider.id}`, payload, riderAuthCfg())
          this.$message.success((resp.data && resp.data.message) || '保存成功')
        } else {
          const resp = await axios.post('/api/riders', payload, riderAuthCfg())
          this.$message.success((resp.data && resp.data.message) || '保存成功')
        }
        this.dialogVisible = false
        this.fetchRiders()
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || '保存失败'
        this.$message.error(msg)
      }
    },
    getStatusText (status) {
      switch (status) {
        case 'idle': return '空闲'
        case 'delivering': return '配送中'
        case 'offline': return '离线'
        default: return status || '未知'
      }
    },
    getStatusClass (status) {
      switch (status) {
        case 'idle': return 'status-idle'
        case 'delivering': return 'status-delivering'
        case 'offline': return 'status-offline'
        default: return 'status-default'
      }
    },
    exportToExcel () {
      if (!this.riders.length) {
        this.$message.info('当前没有可导出的骑手数据')
        return
      }
      const header = ['姓名', '联系方式', '健康证到期时间', '状态']
      const rows = this.riders.map(r => [
        r.name || '',
        r.phone || '',
        this.formatDate(r.health_certificate_expiry) || '',
        this.getStatusText(r.status) || ''
      ])
      const csv = [header.join(','), ...rows.map(r => r.map(v => `"${(v || '').toString().replace(/"/g, '""')}"`).join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      triggerBlobDownload(blob, '骑手信息_导出', 'csv')
      this.$message.success('导出成功，请在浏览器下载中查看。')
    },
    downloadTemplate () {
      const header = ['姓名', '联系方式', '健康证到期时间(YYYY-MM-DD)', '状态(idle/delivering/offline)']
      const csv = header.join(',') + '\n'
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      triggerBlobDownload(blob, '骑手信息_模板', 'csv')
      this.$message.success('模板已下载。')
    },
    handleImport (file) {
      if (!guardUploadFile(this, file, { allowCsv: true })) return false
      const reader = new FileReader()
      reader.onload = (e) => {
        const text = e.target.result
        const validated = validateCsvText(text, { expectedMinCols: 4 })
        if (!validated.ok) {
          this.$message.error(validated.message)
          return
        }
        const lines = validated.lines
        const imported = lines.slice(1).map((line, idx) => {
          const cols = line.split(',').map(c => c.replace(/^"|"$/g, '').replace(/""/g, '"'))
          return {
            id: `imp_${Date.now()}_${idx}`,
            name: cols[0] || '',
            phone: cols[1] || '',
            health_certificate_expiry: cols[2] || '',
            status: cols[3] || 'idle'
          }
        })
        this.riders = imported
        this.$message.success('导入成功')
      }
      reader.readAsText(file, 'utf-8')
      return false
    },
    formatDate (val) {
      const s = this.$formatDate(val)
      return s === '—' ? '' : s
    }
  }
}
</script>

<style scoped>
.rider-region-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 6px;
}

.region-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.region-remove {
  color: #f56c6c;
  flex-shrink: 0;
}

.region-settings-card {
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.06);
  border: none;
  margin-bottom: 16px;
}

.region-settings-body {
  padding: 4px 0 8px;
}

.region-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  min-height: 32px;
}

.region-tag {
  font-size: 13px;
}

.region-empty {
  color: #909399;
  font-size: 13px;
}

.region-add-row {
  display: flex;
  gap: 12px;
  align-items: center;
  max-width: 480px;
}

.region-add-row .el-input {
  flex: 1;
}

.rider-info {
  padding: 24px;
  background: #f5f7fa;
}

.rider-card {
  border-radius: 12px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.06);
  border: none;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
}

.rider-table ::v-deep(.el-table__header-wrapper th) {
  background: #f7f8fa;
  color: #1d2129;
  font-weight: 600;
  padding-top: 14px;
  padding-bottom: 14px;
}

.rider-table ::v-deep(.el-table__header-wrapper thead tr) {
  background: #f7f8fa;
}

.rider-table ::v-deep(.el-table__body-wrapper td) {
  padding-top: 16px;
  padding-bottom: 16px;
}

.rider-table ::v-deep(.el-table__body-wrapper tr:nth-child(2n)) {
  background: #fafafa;
}

.rider-table ::v-deep(.el-table__body-wrapper tr:hover > td) {
  background-color: #f2f3f5 !important;
  transition: background-color 0.2s ease;
}

.rider-table ::v-deep(.el-table__inner-wrapper) {
  border-bottom: 1px solid #e5e6eb;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.status-idle {
  background: #E8F3FF;
  color: #165DFF;
}

.status-delivering {
  background: #FFF7E8;
  color: #FF7D00;
}

.status-offline {
  background: #F5F5F5;
  color: #86909C;
}

.status-default {
  background: #F0F5FF;
  color: #165DFF;
}

.rider-form .el-form-item__content .el-input,
.rider-form .el-form-item__content .el-select,
.rider-form .el-form-item__content .el-date-editor {
  width: 100%;
}
</style>

